import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/hooks';
import { useCreateTVChannel } from '@/hooks';
import { CreateTVChannelRequest } from '@/types/model';
import TVChannelForm from '@/components/forms/TVChannelForm';
import Button from '@/components/ui/Button.tsx';
import toast from 'react-hot-toast';

const CreateTVChannel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const createTVChannelMutation = useCreateTVChannel();

  const handleSuccess = async (data: CreateTVChannelRequest) => {
    try {
      await createTVChannelMutation.mutateAsync(data);
      toast.success(t.tvChannels.messages.created);
      navigate(-1);
    } catch (error) {
      console.error('Create error:', error);
      toast.error(error instanceof Error ? error.message : t.errors.unexpectedError);
      throw error; // Re-throw to let form handle the error
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={handleCancel}
          variant="link"
        >
          ← Volver a la lista
        </Button>

        <TVChannelForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isSubmitting={createTVChannelMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateTVChannel;
